import type { ObservabilityLogLine } from '@/lib/apiClient';
import { formatTime } from '@/lib/format';

const severityFor = (message: string): 'debug' | 'error' | 'info' | 'warning' => {
  const normalized = message.toLowerCase();
  if (/\b(error|exception|fatal|traceback)\b/.test(normalized)) return 'error';
  if (/\b(warn|warning|timeout|retry)\b/.test(normalized)) return 'warning';
  if (/\b(debug|trace)\b/.test(normalized)) return 'debug';
  return 'info';
};

export const VirtualLogList = ({ events, source, wrap }: { events: ObservabilityLogLine[]; source: string; wrap: boolean }) => (
  <ol aria-label="Bounded log events" className="border-ink bg-ink h-96 overflow-auto rounded-md border">
    {events.map((event) => {
      const severity = severityFor(event.message);
      return (
        <li
          className="technical border-muted/35 text-canvas grid gap-1 border-b px-3 py-2 text-xs sm:grid-cols-[11rem_5rem_minmax(8rem,12rem)_minmax(0,1fr)]"
          key={event.eventId ?? `${event.timestamp}:${event.message}`}
        >
          <time className="text-line-strong" dateTime={event.timestamp}>
            {formatTime(event.timestamp)}
          </time>
          <span className="text-line-strong uppercase">{severity}</span>
          <span className="text-line-strong truncate" title={source}>
            {source}
          </span>
          <span className={wrap ? 'break-words whitespace-pre-wrap' : 'overflow-x-auto whitespace-pre'}>{event.message}</span>
        </li>
      );
    })}
  </ol>
);
